import React, { useEffect, useRef, useState } from 'react'
import { Button, Input, Text } from '@mercai/clever'

import { Message } from './components'

import { isKaiManagement } from '@/helpers'
import { useAuth } from '@/providers'

import { useTranslation } from 'react-i18next'

import type { ChatProps } from './chat.type'

import styles from './chat.module.css'

export const Chat = ({
  messages,
  onSendMessage,
  isLoading,
  origin,
  isAiPaused,
  onToggleAiPaused,
  isExpired,
  isAiPausing,
}: ChatProps) => {
  const { t } = useTranslation('screenAiCenter')

  const [message, setMessage] = useState('')
  const contentRef = useRef<HTMLDivElement>(null)

  const { whoAmI } = useAuth()

  const handleSendMessage = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    event.stopPropagation()

    onSendMessage(message)

    setMessage('')
  }

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollTo({
        top: contentRef.current.scrollHeight,
        behavior: 'smooth',
      })
    }
  }, [messages])

  const showToggleAiPaused =
    origin === 'whatsapp' &&
    isKaiManagement(whoAmI?.email) &&
    !isExpired &&
    !isAiPaused

  const showInput =
    origin === 'whatsapp' &&
    isKaiManagement(whoAmI?.email) &&
    !isExpired &&
    isAiPaused

  return (
    <div className={styles.core}>
      <div className={styles.content} ref={contentRef}>
        {messages?.map((message, index) => (
          <Message {...message} isLoading={false} key={index} />
        ))}

        {isLoading && (
          <Message author="assistant" content="Loading..." isLoading={true} />
        )}
      </div>

      {isExpired && (
        <div className={styles.send}>
          <div className={styles['box-info']}>
            <Text className={styles['box-info-description']}>
              {t('drawerChatExpiredAIDescription')}
            </Text>
          </div>
        </div>
      )}

      {showToggleAiPaused && (
        <div className={styles.send}>
          <div className={styles['box-info']}>
            <Text className={styles['box-info-description']}>
              {t('drawerChatPausedAIDescription')}
            </Text>

            <Button onClick={onToggleAiPaused} isLoading={isAiPausing}>
              {t('drawerChatPausedAIButton')}
            </Button>
          </div>
        </div>
      )}

      {showInput && (
        <form className={styles.send} onSubmit={handleSendMessage}>
          <Input
            value={message}
            onChange={setMessage}
            placeholder={t('drawerChatInputPlaceholder')}
          />
          <Button type="submit">{t('drawerChatButtonSend')}</Button>
        </form>
      )}
    </div>
  )
}
